var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "coupon-category-app-container",
      staticStyle: { position: "relative", height: "100%" },
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            top: _vm.dialogTopMargin,
            title: "[" + _vm.travelName + "] - 分房表",
            visible: _vm.dialogVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "tag-container" },
                _vm._l(_vm.travelerRooms, function (tab, index) {
                  return _c(
                    "div",
                    {
                      key: index + "_" + tab.day,
                      staticClass: "tag-item",
                      class: { "tag-item--active": _vm.activeTab == index },
                      on: {
                        click: function ($event) {
                          _vm.activeTab = index
                        },
                      },
                    },
                    [_vm._v(" 第" + _vm._s(tab.day) + "天 ")]
                  )
                }),
                0
              ),
              _c("p", { staticClass: "hotel-title" }, [
                _c("i", { staticClass: "el-icon-s-home" }),
                _vm._v(
                  " 住宿旅館：" +
                    _vm._s(
                      _vm.travelerRooms[_vm.activeTab] &&
                        _vm.travelerRooms[_vm.activeTab].hotelName
                        ? _vm.travelerRooms[_vm.activeTab].hotelName
                        : "未設定"
                    ) +
                    " "
                ),
              ]),
              _vm.travelerRooms[_vm.activeTab] &&
              _vm.travelerRooms[_vm.activeTab].travelersRoomList
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { overflow: "auto" },
                          attrs: {
                            "header-cell-style": {
                              background: "#eee",
                              color: "#000",
                            },
                            size: "mini",
                            border: "",
                            "span-method": _vm.handleSpanMethod,
                            data: _vm.travelerRooms[_vm.activeTab]
                              .travelersRoomList,
                            "max-height": "50vh",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "項次",
                              width: "60",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.$index + 1)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4178052834
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              property: "travelersGroup",
                              label: "分組",
                              width: "120",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              property: "travelersRoomName",
                              label: "房號",
                              width: "200",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm.editRowStatus === 1
                                        ? _c("el-input", {
                                            model: {
                                              value:
                                                scope.row.travelersRoomName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "travelersRoomName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.travelersRoomName",
                                            },
                                          })
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.travelersRoomName
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1173640609
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              property: "travelersIdentity",
                              label: "身份",
                              width: "150",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              property: "travelersName",
                              label: "旅客姓名",
                              width: "150",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              property: "mobile",
                              label: "電話號碼",
                              width: "100",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              property: "agencyRemind",
                              label: "旅行社提醒",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              property: "leaderRemind",
                              label: "領隊備註",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.editRowStatus === 1
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { color: "#4b4b4b" },
                          attrs: { type: "warning" },
                          on: { click: _vm.handleSetTravelersRoomHistory },
                        },
                        [_vm._v("儲 存")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入團號/團名" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getList($event)
                  },
                },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          _c("el-button", {
            staticStyle: { "margin-top": "8px", "margin-left": "5px" },
            attrs: {
              type: "primary",
              icon: "el-icon-search",
              circle: "",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.getList },
          }),
          _c("el-button", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.listLoading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading || _vm.dialogLoading,
                  expression: "listLoading || dialogLoading",
                },
              ],
              ref: "formDetailsTable",
              staticStyle: { width: "100%" },
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "tourGroupNo",
                  label: "團號",
                  width: "200",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "團名", width: "450" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [_vm._v(_vm._s(row.travelName))]),
                        _c(
                          "div",
                          [
                            _c(
                              "el-tag",
                              { staticStyle: { "font-size": "14px" } },
                              [
                                _vm._v(" 出發 "),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(row.beginDate + " " + row.beginTime)
                                  ),
                                ]),
                                _vm._v(" - 回程 "),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(row.endDate + " " + row.endTime)
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "狀態", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.statusTranslateStyle(scope.row.status),
                            },
                          },
                          [_vm._v(_vm._s(scope.row.statusDesc))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "查看分房表", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleGetTravelersRoomHistory(
                                  scope.row
                                )
                              },
                            },
                          },
                          [_vm._v("查看分房表")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }